/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_2_DetailInputs */

const en_cap_promise_2_detail = /** @type {(inputs: Cap_Promise_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it may do, spend and send, and what waits for a person.`)
};

const lv_cap_promise_2_detail = /** @type {(inputs: Cap_Promise_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko tā drīkst darīt, tērēt un sūtīt, un kas gaida cilvēku.`)
};

/**
* | output |
* | --- |
* | "What it may do, spend and send, and what waits for a person." |
*
* @param {Cap_Promise_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_2_detail = /** @type {((inputs?: Cap_Promise_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_2_detail(inputs)
	return en_cap_promise_2_detail(inputs)
});